import React from 'react';
import { Smartphone, Lock, Bell, FileText, Download, ShieldCheck, Star, Zap, Cloud, Users, TrendingUp, CheckCircle2, ArrowRight, Sparkles, MessageSquare, LayoutDashboard, Lightbulb, FolderOpen, Send, Umbrella } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { AnimatedGridPattern } from '../components/ui/AnimatedGridPattern';
interface AppPageProps {
  onNavigate: (page: string) => void;
}
export function AppPage({
  onNavigate
}: AppPageProps) {
  return <div className="min-h-screen bg-sp-light dark:bg-slate-950 transition-colors duration-300" data-id="element-319">
      {/* Hero Section - UNCHANGED */}
      <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50/30 to-sky-50/40 dark:from-slate-950 dark:via-slate-900 dark:to-blue-950/20 pt-28 pb-32 lg:pt-44 lg:pb-48 transition-colors duration-300" data-id="element-320">
        {/* Animated Grid Pattern Background */}
        <AnimatedGridPattern numSquares={30} maxOpacity={0.15} duration={3} repeatDelay={1} className="[mask-image:radial-gradient(600px_circle_at_center,white,transparent)] inset-x-0 inset-y-[-30%] h-[200%] skew-y-12" data-id="element-321" />

        {/* Gradient Overlay */}
        <div className="absolute inset-0 -z-5" data-id="element-322">
          <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-transparent to-white/80 dark:from-slate-950/60 dark:to-slate-950/80" data-id="element-323"></div>
        </div>

        {/* Background Orbs */}
        <div className="absolute inset-0 -z-10" data-id="element-324">
          <div className="absolute top-20 right-1/4 h-[500px] w-[500px] rounded-full bg-gradient-to-br from-blue-400/10 to-sky-400/10 dark:from-blue-500/5 dark:to-sky-500/5 blur-3xl animate-float" data-id="element-325"></div>
          <div className="absolute bottom-20 left-1/4 h-[450px] w-[450px] rounded-full bg-gradient-to-tr from-sky-400/10 to-blue-400/10 dark:from-sky-500/5 dark:to-blue-500/5 blur-3xl animate-float" style={{
          animationDelay: '5s',
          animationDuration: '25s'
        }} data-id="element-326"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-327">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-328">
            <div className="space-y-10" data-id="element-329">
              {/* Badge */}

              {/* Title */}
              <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold tracking-tight leading-[1.1]" data-id="element-330">
                <span className="text-slate-900 dark:text-white" data-id="element-331">Die </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-blue-500 to-sky-500 dark:from-blue-400 dark:via-blue-300 dark:to-sky-400" data-id="element-332">
                  Simplr
                </span>
                <span className="text-slate-900 dark:text-white" data-id="element-333"> App</span>
              </h1>

              {/* Subtitle */}
              <p className="text-xl sm:text-2xl text-slate-600 dark:text-slate-300 max-w-lg leading-relaxed font-light" data-id="element-334">
                Dein digitaler Versicherungsmanager für die Hosentasche.
                Verwalten, optimieren und sparen – jederzeit und überall.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-335">
                <Button size="lg" variant="premium" className="gap-2.5 text-lg px-8 h-14 shadow-2xl shadow-blue-500/25 hover:shadow-blue-500/40 transition-all duration-300 hover:scale-105" data-id="element-336">
                  <Download className="h-5 w-5" data-id="element-337" />
                  iOS Download
                </Button>
                <Button size="lg" variant="outline" className="text-lg px-8 h-14 border-2 hover:border-blue-400 dark:border-slate-700 dark:text-white dark:hover:bg-slate-800/70 hover:bg-blue-50/70 backdrop-blur-sm transition-all duration-300 hover:scale-105" data-id="element-338">
                  <Download className="h-5 w-5 mr-2" data-id="element-339" />
                  Android Download
                </Button>
              </div>

              {/* Social Proof */}
            </div>

            {/* Phone Mockup */}
            <div className="relative hidden lg:block" data-id="element-340">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-sky-500/20 blur-[100px] rounded-full" data-id="element-341"></div>
              <div className="mx-auto w-[300px] h-[600px] bg-slate-950 rounded-[3rem] border-[6px] border-slate-800 shadow-2xl flex items-center justify-center overflow-hidden relative z-10 ring-1 ring-white/10" data-id="element-342">
                <div className="w-full h-full bg-gradient-to-b from-slate-900 to-slate-950 flex flex-col relative" data-id="element-343">
                  {/* Notch */}
                  <div className="absolute top-0 w-full h-7 bg-black/50 z-20 flex justify-center" data-id="element-344">
                    <div className="w-28 h-5 bg-black rounded-b-xl" data-id="element-345"></div>
                  </div>
                  {/* Screen Content */}
                  <div className="h-full w-full bg-gradient-to-b from-slate-800 to-slate-900 flex flex-col items-center justify-center p-5 pt-10" data-id="element-346">
                    <div className="relative mb-5" data-id="element-347">
                      <ShieldCheck className="h-16 w-16 text-blue-500" data-id="element-348" />
                      <div className="absolute inset-0 bg-blue-500 blur-xl opacity-40 animate-pulse" data-id="element-349"></div>
                    </div>
                    <h3 className="text-white font-bold text-xl mb-1" data-id="element-350">
                      Simplr
                    </h3>
                    <p className="text-slate-500 text-center text-sm mb-6" data-id="element-351">
                      Dein Schutz ist aktiv.
                    </p>

                    {/* Mock UI */}
                    <div className="w-full space-y-2.5" data-id="element-352">
                      {[{
                      icon: FileText,
                      color: 'blue'
                    }, {
                      icon: ShieldCheck,
                      color: 'green'
                    }, {
                      icon: TrendingUp,
                      color: 'purple'
                    }].map((item, i) => <div key={i} className="h-16 bg-slate-800/60 rounded-xl border border-slate-700 w-full p-3 flex items-center gap-3" data-id="element-353">
                          <div className={`h-10 w-10 rounded-lg bg-${item.color}-500/20 flex items-center justify-center`} data-id="element-354">
                            <item.icon className={`h-5 w-5 text-${item.color}-400`} data-id="element-355" />
                          </div>
                          <div className="flex-1" data-id="element-356">
                            <div className="h-2.5 bg-slate-700 rounded w-3/4 mb-1.5" data-id="element-357"></div>
                            <div className="h-2 bg-slate-700/50 rounded w-1/2" data-id="element-358"></div>
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Funktionen die begeistern Section */}
      <section className="py-14 px-4 md:px-6 bg-white dark:bg-slate-900" data-id="element-359">
        <div className="container mx-auto max-w-5xl" data-id="element-360">
          <div className="text-center mb-10" data-id="element-361">
            <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 dark:text-white mb-3" data-id="element-362">
              Funktionen die begeistern
            </h2>
            <p className="text-base text-slate-600 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-363">
              Alles an einem Ort: Verträge, Dokumente und Kommunikation.
              Praktisch im Alltag – und im Schadensfall.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5 mb-8" data-id="element-364">
            {/* Feature 1 */}
            <div className="bg-slate-50/80 dark:bg-slate-800/40 p-5 rounded-xl border border-slate-100 dark:border-slate-700/50 hover:border-slate-200 dark:hover:border-slate-600 hover:shadow-md transition-all duration-200" data-id="element-365">
              <div className="h-10 w-10 bg-blue-50 dark:bg-blue-900/20 rounded-lg flex items-center justify-center mb-4 text-blue-600 dark:text-blue-400" data-id="element-366">
                <FileText className="h-5 w-5" data-id="element-367" />
              </div>
              <h3 className="text-base font-semibold text-slate-900 dark:text-white mb-2" data-id="element-368">
                Verträge & Dokumente an einem Ort
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed" data-id="element-369">
                Nie wieder Ordner wälzen. Alle deine Versicherungspolicen
                digital und griffbereit.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-slate-50/80 dark:bg-slate-800/40 p-5 rounded-xl border border-slate-100 dark:border-slate-700/50 hover:border-slate-200 dark:hover:border-slate-600 hover:shadow-md transition-all duration-200" data-id="element-370">
              <div className="h-10 w-10 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg flex items-center justify-center mb-4 text-indigo-600 dark:text-indigo-400" data-id="element-371">
                <MessageSquare className="h-5 w-5" data-id="element-372" />
              </div>
              <h3 className="text-base font-semibold text-slate-900 dark:text-white mb-2" data-id="element-373">
                Kommunikation gebündelt
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed" data-id="element-374">
                Direkter Draht zu deinem Berater. Fragen stellen und Antworten
                erhalten – alles in einer App.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-slate-50/80 dark:bg-slate-800/40 p-5 rounded-xl border border-slate-100 dark:border-slate-700/50 hover:border-slate-200 dark:hover:border-slate-600 hover:shadow-md transition-all duration-200" data-id="element-375">
              <div className="h-10 w-10 bg-sky-50 dark:bg-sky-900/20 rounded-lg flex items-center justify-center mb-4 text-sky-600 dark:text-sky-400" data-id="element-376">
                <LayoutDashboard className="h-5 w-5" data-id="element-377" />
              </div>
              <h3 className="text-base font-semibold text-slate-900 dark:text-white mb-2" data-id="element-378">
                Überblick jederzeit
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed" data-id="element-379">
                Volle Transparenz über deine Finanzen und Versicherungen.
                Jederzeit und überall verfügbar.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-380">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 rounded-full text-xs font-medium" data-id="element-381">
              <Smartphone className="h-3.5 w-3.5" data-id="element-382" />
              Auf dem Handy nutzt du unsere Rechner am besten über die App.
            </span>
          </div>
        </div>
      </section>

      {/* Tipp / Registrierung Section */}
      <section className="py-10 px-4 md:px-6 bg-slate-50 dark:bg-slate-950 border-y border-slate-100 dark:border-slate-800/50" data-id="element-383">
        <div className="container mx-auto max-w-3xl" data-id="element-384">
          <div className="bg-gradient-to-r from-amber-50/80 to-orange-50/80 dark:from-amber-950/20 dark:to-orange-950/20 border border-amber-200/60 dark:border-amber-800/30 rounded-xl px-6 py-5 flex flex-col sm:flex-row items-center gap-5" data-id="element-385">
            <div className="h-10 w-10 bg-amber-100 dark:bg-amber-900/40 rounded-lg flex items-center justify-center flex-shrink-0 text-amber-600 dark:text-amber-400" data-id="element-386">
              <Lightbulb className="h-5 w-5" data-id="element-387" />
            </div>
            <div className="flex-1 text-center sm:text-left" data-id="element-388">
              <p className="text-sm text-slate-700 dark:text-slate-300" data-id="element-389">
                <span className="font-semibold" data-id="element-390">Tipp:</span> In der App hast du
                im Ernstfall alle Unterlagen sofort griffbereit.
              </p>
            </div>
            <div className="flex-shrink-0" data-id="element-391">
              <Button variant="default" size="sm" className="bg-amber-600 hover:bg-amber-700 text-white border-none text-xs px-4" data-id="element-392">
                Jetzt registrieren
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Wofür du sie nutzt Section */}
      <section className="py-14 px-4 md:px-6 bg-white dark:bg-slate-900" data-id="element-393">
        <div className="container mx-auto max-w-5xl" data-id="element-394">
          <div className="text-center mb-10" data-id="element-395">
            <h2 className="text-2xl md:text-3xl font-semibold text-slate-900 dark:text-white mb-3" data-id="element-396">
              Wofür du sie nutzt
            </h2>
            <p className="text-sm text-slate-600 dark:text-slate-400 max-w-xl mx-auto" data-id="element-397">
              Die Simplr App macht dein Leben einfacher und sicherer.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-398">
            {/* Use Case 1 */}
            <div className="flex flex-col items-center text-center p-4" data-id="element-399">
              <div className="h-12 w-12 bg-slate-100 dark:bg-slate-800 rounded-xl flex items-center justify-center mb-4 text-slate-500 dark:text-slate-400" data-id="element-400">
                <FolderOpen className="h-6 w-6" data-id="element-401" />
              </div>
              <h3 className="text-sm font-semibold text-slate-900 dark:text-white mb-2" data-id="element-402">
                Dokumente und Policen übersichtlich ablegen
              </h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-403">
                Kein Papierchaos mehr. Speichere alle wichtigen Unterlagen
                sicher und strukturiert.
              </p>
            </div>

            {/* Use Case 2 */}
            <div className="flex flex-col items-center text-center p-4" data-id="element-404">
              <div className="h-12 w-12 bg-slate-100 dark:bg-slate-800 rounded-xl flex items-center justify-center mb-4 text-slate-500 dark:text-slate-400" data-id="element-405">
                <Send className="h-6 w-6" data-id="element-406" />
              </div>
              <h3 className="text-sm font-semibold text-slate-900 dark:text-white mb-2" data-id="element-407">
                Änderungen und Anfragen gebündelt senden
              </h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-408">
                Adresse geändert? Teile Änderungen mit einem Klick all deinen
                Versicherern mit.
              </p>
            </div>

            {/* Use Case 3 */}
            <div className="flex flex-col items-center text-center p-4" data-id="element-409">
              <div className="h-12 w-12 bg-slate-100 dark:bg-slate-800 rounded-xl flex items-center justify-center mb-4 text-slate-500 dark:text-slate-400" data-id="element-410">
                <Umbrella className="h-6 w-6" data-id="element-411" />
              </div>
              <h3 className="text-sm font-semibold text-slate-900 dark:text-white mb-2" data-id="element-412">
                Im Schadensfall schneller die richtigen Infos parat
              </h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-413">
                Wenn es drauf ankommt, zählt jede Sekunde. Alle Notfallnummern
                sofort zur Hand.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-12 px-4 md:px-6 bg-slate-50 dark:bg-slate-950" data-id="element-414">
        <div className="container mx-auto max-w-3xl text-center" data-id="element-415">
          <h2 className="text-xl md:text-2xl font-semibold text-slate-900 dark:text-white mb-6" data-id="element-416">
            Bereit für den digitalen Überblick?
          </h2>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-417">
            <Button size="default" variant="premium" className="gap-2 px-6" data-id="element-418">
              <Download className="h-4 w-4" data-id="element-419" />
              App herunterladen
            </Button>
            <Button size="default" variant="outline" className="gap-2 px-6" onClick={() => onNavigate('beratung')} data-id="element-420">
              Beratungstermin vereinbaren
              <ArrowRight className="h-4 w-4" data-id="element-421" />
            </Button>
          </div>
        </div>
      </section>
    </div>;
}